module.exports = __webpack_public_path__ + "img/profile-style-img3.7b5ab6d7.png";